import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { SellPayout, SellPayoutListResponse, SellPayoutRequest } from './types'

export const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'id') {
        return ['id', item[1]?.toLowerCase()]
      } else if (item[0] === 'updatedAt' || item[0] === 'createdAt') {
        const value =
          Array.isArray(item[1]) &&
          item[1].map((date) =>
            date ? changedDateFormat(date?.$d) : `${date}`,
          )
        return [item[0], value]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}

export const sellPayoutListMounted = createEvent<SellPayoutRequest>()

export const sellPayoutListWithoutPaginationMounted = createEvent()

export const getSellPayoutList = fx<SellPayoutRequest, SellPayoutListResponse>({
  method: 'GET',
  url: `/nova/p2p-sell-offer-sell`,
})

export const getSellPayoutWithoutPaginationList = fx<
  void,
  SellPayoutListResponse
>({
  method: 'GET',
  url: `/nova/p2p-sell-offer-sell`,
})

export const $sellPayouts = restore<SellPayout[]>(
  getSellPayoutList.doneData.map((a) => {
    return a.body.items.map((item) => {
      return {
        ...item,
      }
    })
  }),
  [],
)

export const $sellPayoutsWithoutPagination = restore<SellPayout[]>(
  getSellPayoutWithoutPaginationList.doneData.map((a) => {
    return a.body.items.map((item) => {
      return {
        ...item,
      }
    })
  }),
  [],
)

export const $totalCountOfSellPayouts = restore(
  getSellPayoutList.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: sellPayoutListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection == 'descend') {
      orderDirection = '-'
    } else if (orderDirection == 'ascend') {
      orderDirection = ''
    }
    orderBy = 'id'
    let query = {
      limit,
      page,
    }
    // @ts-ignore
    if (orderBy != '') {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }
    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'status'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }

    return {
      query,
    }
  },
  target: getSellPayoutList,
})

sample({
  // @ts-ignore
  clock: sellPayoutListWithoutPaginationMounted,
  target: getSellPayoutWithoutPaginationList,
})
